import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";

const initialState = {
	loading: null,
	serverErrors: null,
	response: []
};
// remove this
const updateMyPasswordStart = (state, action) => {
	return updateObject(state, {
		serverErrors: null,
		loading: false,
		response: []
	});
};
/**
 * @function updateMyPassword
 * @param {string} state - State before reducer.
 * @param {object} action - Action sent to reducer.
 * @returns {string} - New state (updateMyPassword payload from action).
 */
// remove this
const updateMyPasswordSuccess = (state, action) => {
	return updateObject(state, {
		response: action.response,
		loading: false
	});
};
// remove this
const updateMyPasswordFail = (state, action) => {
	return updateObject(state, {
		serverErrors: action.error,
		loading: false
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.UPDATE_MY_PASSWORD_START: // remove this
			return updateMyPasswordStart(state, action);
		case actionTypes.UPDATE_MY_PASSWORD_SUCCESS: // remove this
			return updateMyPasswordSuccess(state, action);
		case actionTypes.UPDATE_MY_PASSWORD_FAIL: // remove this
			return updateMyPasswordFail(state, action);
		default:
			return state;
	}
};

export default reducer;
